import { call, put, select } from 'redux-saga/effects'
import { get } from 'lodash'

import ItemModel from '../models/item'
import ItemSearchActions from '../reducers/hasuraSearchItemReducer'
import ItemSyncActions from '../reducers/itemSyncReducer'
import Hasura from '../config/hasura'

function transformItemStructure(items) {
  return items.map(i =>
    Object.assign(i, {
      images: { image: get(i, 'image.image', null), thumb: get(i, 'thumb.image', null) },
      options: i.options.reduce((accum, o) => {
        // eslint-disable-next-line no-param-reassign
        accum[o.firebase_key] = { order: o.order_number }
        return accum
      }, {}),
    })
  )
}

export function* searchItems({ merchantKey, searchText }) {
  if (searchText === '') return yield put(ItemSearchActions.searchItemSuccess([]))

  const formatSearchKeyword = `%${searchText}%`

  try {
    const query = `
      query($merchantKey: String!, $searchKeyword: String!){
        items(where: {merchant_key: {_eq: $merchantKey}, _or: [{name: {_ilike: $searchKeyword}}, {code: {_ilike: $searchKeyword}}]}, limit: 50) {
          key: firebase_key
          code
          name
          description
          current_price: price
          status
          tag: tag_key
          options{
            firebase_key
            order_number
          }
          image {
            image
          }
          thumb {
            image
          }
        }
      }
    `

    const variables = { merchantKey, searchKeyword: formatSearchKeyword }
    const { items } = yield call(Hasura.execute, query, variables)

    const orderedItems = items.length > 0 ? transformItemStructure(items) : items

    yield put(ItemSearchActions.searchItemSuccess(orderedItems))
  } catch (err) {
    yield put(ItemSearchActions.searchItemError(err))
  }

  return null
}

export function* updateAlterItems({ merchantKey }) {
  try {
    const items = yield select(state => state.hasuraSearchItems.alterItems)

    yield call([ItemModel, ItemModel.updateItems], merchantKey, items)

    yield put(ItemSyncActions.syncMerchantItems(merchantKey))

    yield put(ItemSearchActions.updateAlterItemSuccess())
  } catch (err) {
    yield put(ItemSearchActions.updateItemErrors(err))
  }
}



// WEBPACK FOOTER //
// ./src/sagas/hasuraSearchItemSaga.js